import { Button, Grid, TextField } from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import { useCreateCommodityMutation } from "../../../services/costs/costsService";
import { Alert } from "@material-ui/lab";
import { useEffect } from "react";

const noWhiteSpace = /^[^\s]+$/;

const AddNewCommodityForm = () => {
  // Queries
  const [create, { isSuccess, error, reset }] = useCreateCommodityMutation();

  const schema = yup.object().shape({
    nombre: yup
      .string()
      .matches(noWhiteSpace, "No espacios en blanco")
      .required("Campo requerido"),
    descripcion: yup.string().required("Campo requerido"),
  });

  const { setFieldValue, values, errors, touched, handleSubmit, resetForm } =
    useFormik({
      initialValues: {
        nombre: "",
        descripcion: "",
      },
      validationSchema: schema,
      onSubmit(values) {
        reset();
        create(values);
      },
    });

  useEffect(() => {
    if (isSuccess === true) {
      resetForm();
    }
  }, [isSuccess, resetForm]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Código"
            variant="outlined"
            fullWidth
            onChange={(e) =>
              setFieldValue("nombre", e.target.value.toUpperCase())
            }
            value={values.nombre}
            helperText={errors.nombre}
            error={Boolean(errors.nombre && touched.nombre)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Desripcion"
            variant="outlined"
            fullWidth
            multiline
            minRows={4}
            onChange={(e) =>
              setFieldValue("descripcion", e.target.value.toUpperCase())
            }
            value={values.descripcion}
            helperText={errors.descripcion}
            error={Boolean(errors.descripcion && touched.descripcion)}
          />
        </Grid>
        <Grid item xs={12}>
          {isSuccess && (
            <Alert severity="success">Commodity creado correctamente</Alert>
          )}
          {Boolean(error !== undefined) && (
            <Alert severity="error">{String(error)}</Alert>
          )}
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSubmit()}
            fullWidth
            size="large"
          >
            Guardar
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default AddNewCommodityForm;
